export const SET_tipos_instrumentoS =
  "tipos_instrumentoS/SET_tipos_instrumentoS";
export const SET_tipo_instrumento = "tipos_instrumentoS/SET_tipo_instrumento";
export const SET_PAGINATION = "tipos_instrumentoS/SET_PAGINATION";
